<template>
  <div class="pb-2">
    <label v-if="label" :for="id" class="label-lg block py-1 px-2">
      <span>{{ label }}</span>
      <span v-if="required" class="text-error"> * </span>
    </label>
    <div class="relative">
      <span
        v-if="icon"
        :class="{
          'absolute left-0 pointer-events-none': true,
          'py-4 px-4': size == 'large',
          'py-3 pl-4 pr-3': size == 'normal',
        }"
      >
        <Icon
          :name="icon"
          :class="{
            'fill-[#9ca3af]': !isInputFocused && isInputEmpty,
            'fill-on-surface/75': isInputFocused || !isInputEmpty,
            'fill-error': error,
          }"
        />
      </span>
      <input
        :id="id"
        ref="input"
        v-bind="$attrs"
        :type="type"
        :value="value"
        :required="required"
        :placeholder="placeholder"
        :class="{
          'body-lg w-full block': true,
          'rounded-full': rounded,
          'rounded-lg': !rounded,
          'h-14 py-4 px-6': size == 'large',
          'h-12 p-3 pl-4': size == 'normal',
          'border border-outline focus:outline-none focus:border-primary focus:ring focus:ring-primary-container active:outline-none': !elevated,
          'elevation-1 border border-transparent transition-shadow duration-300 hover:elevation-2 hover:transition-shadow hover:duration-300 focus:outline-none focus:border active:elevation-2 focus:elevation-2': elevated,
          'pl-14': icon, // Add padding if icon present
          'border-error': error,
        }"
        @input="handleInput($event)"
        @focus="isInputFocused = true"
        @blur="isInputFocused = false"
      />
    </div>
    <div v-if="error || hint" class="text-caption py-1 px-2 text-neutral40 opacity-80">
      <p v-if="error" class="text-error">{{ error.charAt(0).toUpperCase() + error.slice(1) }}</p>
      <p v-else-if="hint">{{ hint }}</p>
    </div>
  </div>
</template>

<script>
import Icon from '@/Components/Icon'

export default {
  name: 'FormInputText',
  inheritAttrs: false,
  components: { Icon },
  props: {
    error: {
      type: String,
    },
    id: {
      type: String,
      default: '',
    },
    label: {
      type: String,
      default: '',
    },
    required: {
      type: Boolean,
      default: false,
    },
    type: {
      type: String,
      default: 'text',
      validator(value) {
        return ['url', 'text', 'password', 'tel', 'search', 'number', 'email', 'date'].includes(
          value,
        )
      },
    },
    placeholder: {
      type: String,
      default() {
        return this.type === 'password'
          ? '\u2217\u2217\u2217\u2217\u2217\u2217\u2217\u2217\u2217\u2217\u2217\u2217'
          : ''
      },
    },
    value: {
      type: null,
      default: '',
    },
    rounded: { type: Boolean, default: false },
    size: {
      type: String,
      default: 'normal',
      validator: value => ['normal', 'large'].includes(value),
    },
    elevated: {
      type: Boolean,
      default: false,
    },
    icon: String,
    icon_color: String,
    hint: String,
  },
  data() {
    return {
      isInputFocused: false,
      isInputEmpty: true,
    }
  },
  methods: {
    focus() {
      this.$refs.input.focus()
    },
    select() {
      this.$refs.input.select()
    },
    handleInput(event) {
      this.isInputEmpty = event.target.value.length == 0
      this.$emit('input', event.target.value)
    },
  },
}
</script>
